import Icon from "core/assets/icons";
import { toast } from "react-toastify";


const CustomCloseButton = () => (
  <img
    src={Icon.CloseWhite}
    alt="CloseWhite"
    onClick={() => { toast.dismiss() }} // Gọi hàm đóng toast
    style={{ cursor: "pointer" }} // Đảm bảo có thể click
  />
);

const CToast = (msg: any) => {
  toast.dismiss();
  toast(msg, {
    icon: <img src={Icon.TickWhite} alt={'TickWhite'} />,
    closeButton: <CustomCloseButton />, // Sử dụng component tùy chỉnh
    autoClose: 5000, // Đảm bảo toast tự đóng sau 5s
  });
}

export default CToast